import { render, staticRenderFns } from "./TwoFactorsAuthV2.vue?vue&type=template&id=5e5d28d2&scoped=true"
import script from "./TwoFactorsAuthV2.vue?vue&type=script&lang=js"
export * from "./TwoFactorsAuthV2.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorsAuthV2.vue?vue&type=style&index=0&id=5e5d28d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5d28d2",
  null
  
)

export default component.exports